import useIsomorphicLayoutEffect from "@bookingcom/bui-react/hooks/useIsomorphicLayoutEffect";
var prefix = "WEB_SHELL_UX";
export var COMPONENTS;
(function (COMPONENTS) {
    COMPONENTS["HEADER"] = "header";
    COMPONENTS["FOOTER"] = "footer";
    COMPONENTS["GLOBAL_ALERT"] = "global_alert";
})(COMPONENTS || (COMPONENTS = {}));
export var EVENTS;
(function (EVENTS) {
    EVENTS["LOGO_CLICKED"] = "logo_clicked";
    EVENTS["SOCIAL_ENTRY_CLICKED"] = "social-entrypoint_clicked";
    EVENTS["HELP_CENTER_CLICKED"] = "help-center_clicked";
    EVENTS["LIST_PROPERTY_CLICKED"] = "list-property_clicked";
    EVENTS["SIGN_UP_CLICKED"] = "sign-up_clicked";
    EVENTS["SIGN_IN_CLICKED"] = "sign-in_clicked";
    EVENTS["PROFILE_CLICKED"] = "profile_clicked";
    EVENTS["PROFILE_OPTION_CHOSEN"] = "profile-option_chosen";
    EVENTS["NOTIF_CLICKED"] = "notification_clicked";
    EVENTS["PICKER_CLICKED"] = "picker_clicked";
    EVENTS["PICKER_OPTION_CHOSEN"] = "picker-option_chosen";
    EVENTS["TAB_EXPOSED"] = "xpb-tab_exposed";
    EVENTS["TAB_CLICKED"] = "xpb-tab_clicked";
    EVENTS["MOBILE_MENU_OPEN"] = "mobile_menu_open";
    EVENTS["MOBILE_MENU_CLOSE"] = "mobile_menu_close";
    EVENTS["ASSISTANT_CLICKED"] = "assistant_clicked";
    EVENTS["CURRENCY_PICKER_OPEN"] = "currency-picker_open";
    EVENTS["CURRENCY_PICKER_CLOSE"] = "currency-picker_close";
})(EVENTS || (EVENTS = {}));
export var getEvent = function (name, component) {
    if (component === void 0) { component = COMPONENTS.HEADER; }
    return "".concat(prefix, "_").concat(component, "_").concat(name);
};
export var createEvent = function (name, detail) {
    var event = new CustomEvent(getEvent(name), {
        detail: detail,
    });
    return event;
};
export var dispatchEvent = function (name, detail) {
    if (!window)
        return;
    var event = createEvent(name, detail);
    window.dispatchEvent(event);
};
export var useEventListener = function (name, callback) {
    useIsomorphicLayoutEffect(function () {
        window.addEventListener(getEvent(name), callback);
        return function () {
            window.removeEventListener(getEvent(name), callback);
        };
    }, [name, callback]);
};
